import React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import "../../css/slider-animations.css";
import "../../css/homeslider.css";

const HomeSlider1 = ({ data, contentWrapperCls = "", btnCls = "" }) => {
  const navigate = useNavigate();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 991,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  return (
    <Slider {...settings} className="slider-wrapper home-slider2">
      {data.map((item, index) => (
        <div
          key={index}
          className="slider-content"
          onClick={() => item.link && navigate(item.link)}
          style={{
            background: `url('${item.image}') no-repeat center center`,
            cursor: item.link ? "pointer" : "default",
          }}
        >
          <div className={`inner ${contentWrapperCls}`}>
            {item.title && <h1>{item.title}</h1>}
            {item.description && <p>{item.description}</p>}
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default HomeSlider1;
